const contactsSelector = (state) => state.contact.contacts

export { contactsSelector }
